module.exports = __webpack_public_path__ + "img/cns_mac1.275369c8.png";